// ** Types
import type {
	MegaMenuOverlayProps,
	SearchResult,
	SearchSuggestion,
	SearchViewProps
} from '@/components/common/MegaMenuOverlay/megaMenuOverlay.types';
import type { MenuViewProps } from '@/components/common/MegaMenuOverlay/megaMenuView.types';
import type { SearchOption } from '@/components/common/searchSection/types';

export type MegaMenuMenuViewModel = MenuViewProps;
export type MegaMenuOverlayViewModel = MegaMenuOverlayProps;
export type MegaMenuSearchViewModel = SearchViewProps;
export type MegaMenuSearchSuggestionViewModel = SearchSuggestion;
export type MegaMenuSearchResultViewModel = SearchResult;

export type MegaMenuSearchFilterViewModel = {
	typOptions: SearchOption[];
	themaOptions: SearchOption[];
};
